export const listPath = [
    {
        name: 'Главная',
        path: '/',
    },
    {
        name: 'Кейсы',
        path: '/cases',
    },
    {
        name: 'Разработка',
        path: '/cases/development',
    },
];
export const listTitle = [
    {
        title: 'Создали платформу и&nbsp;датасеты для первичной диагностики пациентов с&nbsp;помощью&nbsp;ИИ',
        subtitle: `Разработали высоконагруженную платформу для конкурсов <a
                                className="aimed-layout-pageLink"
                                href="https://aimfinder.upgreat.one/"
                                target="_blank"
                                rel="noreferrer"
                            >
                                AI&rsquo;m&nbsp;Finder
                            </a>
                            и&nbsp;
                            <a
                                className="aimed-layout-pageLink"
                                href="https://ai4med.upgreat.one/"
                                target="_blank"
                                rel="noreferrer"
                            >
                                AI&rsquo;m Doctor
                            </a> и&nbsp;сформировали уникальные датасеты для обучения российских
                             ИИ-систем, которые станут основой системы поддержки принятия врачебных решений.`,
        description: [
            {
                name: 'Отрасль',
                details: 'Инновации',
            },
            {
                name: 'Услуги',
                details: 'Разработка платформы',
            },
            {
                name: 'Сроки',
                details: 'октябрь 2022 – ноябрь 2024',
            },
        ],
        company: 'Фонд Национальной технологической инициативы (НТИ)\n',
        companyLink: 'https://upgreat.one/',
        companyLinkName: 'upgreat.one',
        text:
            'Фонд организует технологические конкурсы, инженерные соревнования для команд' +
            ' разработчиков, которые предлагают решения критически важных задач' +
            ' в&nbsp;различных сферах, которые имеют критически важное значения' +
            ' для развития технологического рынка России.',
    },
];

export const listStages = [
    {
        number: '1.',
        text: 'Разработать и&nbsp;реализовать систему датасетов с&nbsp;эпикризами пациентов.',
    },
    {
        number: '2.',
        text: 'Валидировать датасеты врачами-экспертами.',
    },
    {
        number: '3.',
        text: 'Реализовать систему разметки эпикризов врачами прямо в&nbsp;браузере.',
    },
    {
        number: '4.',
        text: 'Создать платформу для проведения технологического конкурса.',
    },
    {
        number: '5.',
        text:
            'Реализовать сложный модуль математики, который позволит' +
            ' сравнить разметку команд с&nbsp;помощью&nbsp;ИИ и&nbsp;действия врачей.',
    },
];

export const iconsBlock = [
    {
        title: 'Неполное техническое задание',
        description:
            'Глубинно проработали взаимосвязи ролей, что дало понимание' +
            ' бэкенд-команде о&nbsp;структуре взаимодействия баз данных' +
            ' и&nbsp;модулей системы, облегчило работу фронтенду' +
            ' по&nbsp;синхронизации визуальных сценариев с&nbsp;внутренней логикой.',
        icon: '/images/svg/aimed/icon1.svg',
    },
    {
        title: 'Неоднородность данных с эпикризами',
        description:
            'Университет им. Сеченова предоставил огромный массив данных' +
            ' с&nbsp;эпикризами, но&nbsp;в&nbsp;оригинальных медицинских' +
            ' документах нет единого стандарта. Партнеры из&nbsp;университета' +
            ' универсализировали данные, а&nbsp;мы&nbsp;написали скрипт,' +
            ' чтобы на&nbsp;входе их&nbsp;валидировать.',
        icon: '/images/svg/aimed/icon2.svg',
    },
    {
        title: 'Кодирование большого массива матданных на&nbsp;язык программирования',
        description:
            'Разработали математический аппарат для сравнения результатов' +
            ' участников' +
            ' с&nbsp;эталоном. Формулы предоставили ученые-математики,' +
            ' которые мы&nbsp;переводили на&nbsp;язык программирования.',
        icon: '/images/svg/aimed/icon3.svg',
    },
    {
        title: 'Строгая конфиденциальность данных',
        description:
            'Для сохранности и&nbsp;конфиденциальности данных ограничили' +
            ' действия пользователи разного уровня только в&nbsp;рамках' +
            ' своей задачи. Для защиты от&nbsp;массовых ddos-атак закрыли' +
            ' внешний доступ к&nbsp;базе данных.',
        icon: '/images/svg/aimed/icon4.svg',
    },
];

export const listCompetitions = [
    {
        description:
            'участники беспрепятственно раз в&nbsp;минуту все одновременно получали файлы для работы;',
    },
    {
        description: 'принимали и&nbsp;фиксировали ответы участников;',
    },
    {
        description:
            'на&nbsp;лидерборде в&nbsp;прямом эфире без обновления страницы отображали прогресс по&nbsp;каждой команде-участнику;',
    },
    {
        description: 'оперативно реагировали на&nbsp;любые ситуации.',
    },
];

export const listResults = [
    {
        title: `6 <span>месяцев</span>`,
        description: 'от&nbsp;утверждения дизайна до&nbsp;запуска платформы',
    },
    {
        title: '3 910 <span>эпикризов</span>',
        description: 'загрузили в&nbsp;систему для обработки медэкспертами',
    },
    {
        title: '8 <span>ЛК</span>',
        description: 'разработали для разных ролей на&nbsp;платформе',
    },
    {
        title: '20 <span>часов</span>',
        description: 'бесперебойной работы в финалах конкурсов',
    },
    {
        title: '3 500 <span>часов</span>',
        description: 'тестирования',
    },
    {
        title: '2 000+ <span>сессий</span>',
        description: 'обмена информацией между Платформой и&nbsp;системами участников',
    },
    {
        title: '89 <span>команд</span>',
        description: 'участников конкурсов',
    },
    {
        title: '500+ <span>страниц</span>',
        description: 'документации с&nbsp;описанием функционала',
    },
];

export const listMedia = [
    {
        title: 'В&nbsp;России выберут лучшую ИИ-систему анализа протоколов медосмотров',
        subtitle: 'ТАСС',
        icon: '/images/svg/aimed/media1.svg',
        link: 'https://nauka.tass.ru/nauka/14666135?utm_source=yandex.ru&utm_medium=organic&utm_campaign=yandex.ru&utm_referrer=yandex.ru',
    },
    {
        title: 'Конкурс AI&rsquo;m Doctor&nbsp;&mdash; путь разработчика',
        subtitle: 'SKOLKOVO',
        icon: '/images/svg/aimed/media2.svg',
        link: 'https://sk.ru/news/konkurs-aim-doctor-put-razrabotchika/',
    },
    {
        title: 'Доктор Что: искусственный интеллект помогает врачам',
        subtitle: 'TechInsider',
        icon: '/images/svg/aimed/media3.svg',
        link: 'https://www.techinsider.ru/science/1569335-doktor-chto-iskusstvennyy-intellekt-pomogaet-vracham/',
    },
];

export const listSolutions = [
    {
        description:
            'Также разработали базовую схему и&nbsp;структуру' +
            ' по&nbsp;обеспечению информационной безопасности проекта.',
    },
];

export const listSolutionsRoles = [
    {
        description:
            'Сделали специальный разметчик для классификации симптомов и&nbsp;передали' +
            ' его в&nbsp;тестирование экспертам-медикам.' +
            ' Подготовили проект для тестирования в&nbsp;объеме разработанного функционала.',
    },
];

export const targetList = {
    title: 'Цель',
    description:
        ' Создать в&nbsp;стране технологию для первичной диагностики легочных\n' +
        'заболеваний с&nbsp;помощью искусственного интеллекта. Для решения этой\n' +
        '                        глобальной цели и&nbsp;преодоления технологического барьера в&nbsp;медицине\n' +
        '                        проводятся конкурсы AI&rsquo;m Finder и&nbsp;AI&rsquo;m Doctor',
};

export const listMarker = [
    {
        description:
            'Для этого разработали сервис со&nbsp;сложными математическими расчетами' +
            ' для автоматического вычисления результатов конкурса на&nbsp;основе' +
            ' интегрального критерия. Написали утилиту для обеспечения взаимодействия' +
            ' платформы и&nbsp;систем участников.',
    },
    {
        description:
            'Загрузили на&nbsp;платформу информацию с&nbsp;историями болезней.' +
            ' Врачи заранее поработали с&nbsp;этими карточками и&nbsp;с&nbsp;помощью' +
            ' специального разметчика, разработанного нами, выделили симптомы болезней' +
            ' по&nbsp;каждому пациенту и&nbsp;подтвердили, либо опровергли' +
            ' установленный диагноз.',
    },
];

export const listMarkerStages = [
    {
        description:
            'Настроили облачную систему через сервис Яндекс.Облако для обеспечения' +
            ' отказоустойчивости платформы. Сделали стресс-тестирование платформы,' +
            ' имитировав нагрузку в&nbsp;10&nbsp;раз больше, чем запланировано' +
            ' в&nbsp;дни финальных испытаний.',
    },
];
